// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#progressMsg {
  display: none !important;
}

.ui-progressbar-complete {
  height: 110% !important;
  background-color: #96ceb4 !important;
}

.ui-dialog {
  padding: 0 !important;
  border: none !important;
  border-radius: 7px !important;
  overflow: hidden;
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px !important; */
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px !important;
}

.ui-dialog-titlebar {
  border: none !important;
  border-radius: 0 !important;
}

.ui-dialog-buttonpane {
  padding: 0.5rem !important;
}

.ui-dialog-buttonset button {
  background-color: #999 !important;
  padding: 0.5rem 1rem !important;
  border: none !important;
  outline: none !important;
  border-radius: 7px !important;
  font-weight: bold !important;
}

.ui-dialog-buttonset button:hover {
  outline: 2px solid #999 !important;
  outline-offset: 0.2rem !important;
}

.ui-dialog-buttonset button:active {
  outline: 2px solid #999 !important;
  outline-offset: 0.2rem !important;
  background-color: #bbb !important;
}

.ui-dialog-content {
  padding: 0.5rem 1rem 1rem 1rem !important;
}

.ui-dialog-content input {
  pointer-events: none !important;
}

/* -------------------------------------------------------------------------- */

.hide-ui-dialog .ui-dialog {
  display: none !important;
}

.psychojs-alert-text {
  font-weight: 700;
  font-size: 1.2rem;
  color: rgb(216, 69, 50);
}
`, "",{"version":3,"sources":["webpack://./components/css/psychojsExtra.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,6DAA6D;EAC7D;;kFAEgF;AAClF;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;AACjC;;AAEA,+EAA+E;;AAE/E;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB","sourcesContent":["#progressMsg {\n  display: none !important;\n}\n\n.ui-progressbar-complete {\n  height: 110% !important;\n  background-color: #96ceb4 !important;\n}\n\n.ui-dialog {\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 7px !important;\n  overflow: hidden;\n  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px !important; */\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,\n    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,\n    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px !important;\n}\n\n.ui-dialog-titlebar {\n  border: none !important;\n  border-radius: 0 !important;\n}\n\n.ui-dialog-buttonpane {\n  padding: 0.5rem !important;\n}\n\n.ui-dialog-buttonset button {\n  background-color: #999 !important;\n  padding: 0.5rem 1rem !important;\n  border: none !important;\n  outline: none !important;\n  border-radius: 7px !important;\n  font-weight: bold !important;\n}\n\n.ui-dialog-buttonset button:hover {\n  outline: 2px solid #999 !important;\n  outline-offset: 0.2rem !important;\n}\n\n.ui-dialog-buttonset button:active {\n  outline: 2px solid #999 !important;\n  outline-offset: 0.2rem !important;\n  background-color: #bbb !important;\n}\n\n.ui-dialog-content {\n  padding: 0.5rem 1rem 1rem 1rem !important;\n}\n\n.ui-dialog-content input {\n  pointer-events: none !important;\n}\n\n/* -------------------------------------------------------------------------- */\n\n.hide-ui-dialog .ui-dialog {\n  display: none !important;\n}\n\n.psychojs-alert-text {\n  font-weight: 700;\n  font-size: 1.2rem;\n  color: rgb(216, 69, 50);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
